import { ErrorHandler, Injectable } from "@angular/core";

const CHUNK_FAILED_PATTERN = /Loading chunk [\w-]+ failed/i;
const RELOAD_TIMESTAMP_KEY = "chunkLoadReloadAt";
const RELOAD_GRACE_MS = 30_000;

@Injectable()
export class ChunkErrorHandler implements ErrorHandler {
  handleError(error: unknown): void {
    if (this.isChunkLoadError(error)) {
      const lastReload = Number(sessionStorage.getItem(RELOAD_TIMESTAMP_KEY) ?? 0);
      const now = Date.now();
      if (now - lastReload > RELOAD_GRACE_MS) {
        sessionStorage.setItem(RELOAD_TIMESTAMP_KEY, String(now));
        window.location.reload();
        return;
      }
    }
    console.error(error);
  }

  private isChunkLoadError(error: unknown): boolean {
    if (!error) return false;
    const e = error as { name?: string; message?: string };
    if (e.name === "ChunkLoadError") return true;
    if (typeof e.message === "string" && CHUNK_FAILED_PATTERN.test(e.message)) {
      return true;
    }
    return false;
  }
}
